import { useId } from "react";
import { MultiCheckbox } from "@sprout/checkbox.tsx";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@components/ui/dropdown-menu.tsx";
import { SpecializedMultiSelectFilterProps } from "@components/job_search/filters/multi_select_filter.tsx";
import ArrowDownIcon from "@sprout/icons/arrow_down.tsx";
import { SecondaryButton } from "@sprout/buttons";

export const DesktopMultiSelectFilter = ({
  buttonText,
  onSelect,
  options,
  values,
}: SpecializedMultiSelectFilterProps) => {
  const id = useId();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <SecondaryButton size="medium">
          <div className="flex items-center justify-center gap-1 w-full">
            {buttonText}
            <ArrowDownIcon size="sm" color="green" />
          </div>
        </SecondaryButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" sideOffset={0} className="pt-4 pb-6 px-6">
        <div className="w-48 text-[16px]/[1.5] text-dark-green">
          <MultiCheckbox
            id={id}
            options={options}
            isMulti={true}
            onSelect={onSelect}
            values={values}
            spacing={2}
          />
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
